import gql from 'graphql-tag';

export const CREATE_RENTER_CONFIRMATION_AGREEMENT = gql`
  mutation CreateRenterConfirmationAgreement($input: RenterConfirmationAgreementInput) {
    createRenterConfirmationAgreement(input: $input) {
      agreement {
        id
        confirmed
      }
      error
    }
  }
`;
